import React, { useState } from "react";
import { useParams } from "react-router";
import ToggleDropdown from '../reused-components/SidebarTabs';
import AddProducts from '../reused-components/AddProducts';
import Profile from '../reused-components/Profile';
import smlogo from '../../img/sm-logo.svg';
import profileImage from '../../img/user-profile.png';
import EventTypeFilter from "../reused-components/EventTypeFilter";
import SitesTable from '../tables/SitesTable';
import SearchFilter from "../reused-components/SearchFilter";
import UninstallReasonsDropdown from "../reused-components/UninstallReasonsDropdown";
import DarkModeSwitch from "../reused-components/ToggleDarkMode";
import DownloadDropdown from "../reused-components/DownloadDropdown";
import { fetchSites } from "../../services/apiService";
import { useTelemetryContext } from "../../contexts/TelemetryContext";

const SITES_CSV_COLUMNS = [
    { key: "id", label: "ID" },
    { key: "address", label: "Address" },
    { key: "installed_at", label: "Installed at" },
    { key: "user_id", label: "User ID" },
    { key: "sdk_version", label: "SDK Version" },
    { key: "version", label: "Version" },
    { key: "reason_detail", label: "Reason Detail" },
];

export default function Sites() {
    document.title = "Sites";

    const { productId } = useParams();
    const { selectedProduct } = useTelemetryContext();

    const [perPage, setPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [stateFilter, setStateFilter] = useState('');
    const [planFilter, setPlanFilter] = useState('');
    const [showUninstallReasons, setShowUninstallReasons] = useState(false);
    const [uninstallReason, setUninstallReason] = useState('');
    const [onlyProduction, setOnlyProduction] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);

    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);
    };

    const handleFilterChange = (selectedFilter) => {
        const lowerCaseFilter = selectedFilter.toLowerCase();

        if (lowerCaseFilter === 'pro' || lowerCaseFilter === 'free') {
            setPlanFilter(lowerCaseFilter);
            setStateFilter('');
            setShowUninstallReasons(false);
            setUninstallReason('');
            return;
        }

        setPlanFilter('');
        setStateFilter(lowerCaseFilter === 'all' ? '' : lowerCaseFilter);

        if (lowerCaseFilter === 'deactivate' || lowerCaseFilter === 'uninstall') {
            setShowUninstallReasons(true);
        } else {
            setShowUninstallReasons(false);
            setUninstallReason('');
        }
    };

    return (
        <div className="telemetry-page-wrapper">
            <header className="telemetry-header">
                <div className="telemetry-logo-section">
                    <a href="#"><img src={smlogo} alt="Telemetry" /></a>
                </div>
                <div className="telemetry-top">
                    <h1>Sites</h1>
                    <div className="telemetry-top-right">
					<DarkModeSwitch />
                        <SearchFilter onSearch={handleSearch} />
                        <AddProducts />
                        <Profile image={profileImage} />
                    </div>
                </div>
            </header>
            <main className="telemetry-main">
                <aside className="telemetry-sidebar">
                    <ToggleDropdown tabactive={1} tabactive2={1} />
                </aside>
                <section className="telemetry-content">
                    <div className="telemetry-filter">
                        <div className="telemetry-filter-left">
                            <EventTypeFilter onFilterChange={handleFilterChange} showPlanFilters />
                            {showUninstallReasons && (
                                <UninstallReasonsDropdown 
                                    onReasonSelect={setUninstallReason} 
                                    selectedReason={uninstallReason} 
                                />
                            )}
                        </div>
                        <div className="telemetry-filter-right">
                            <label className="telemetry-checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={onlyProduction}
                                    onChange={(e) => setOnlyProduction(e.target.checked)}
                                />
                                Only Production
                            </label>
                            <DownloadDropdown
                                allLabel="All sites"
                                tableLabel="Table sites"
                                tableData={tableData}
                                columns={SITES_CSV_COLUMNS}
                                filenameBase="sites"
                                onDownloadAll={async () => {
                                    if (!selectedProduct?.id || !productId) return [];
                                    const perPageAll = Math.max(totalRows || 1, 5000);
                                    const res = await fetchSites(
                                        selectedProduct.id,
                                        1,
                                        perPageAll,
                                        null,
                                        searchTerm,
                                        stateFilter || null,
                                        uninstallReason,
                                        onlyProduction
                                    );
                                    return res.data || [];
                                }}
                            />
                        </div>
                    </div>                    
                    <div className="telemetry-data-table-wrapper">
                        <div className="telemetry-data-table-container">
                            <SitesTable 
                                paginationPerPage={perPage} 
                                searchTerm={searchTerm} 
                                stateFilter={stateFilter}
                                planFilter={planFilter}
                                uninstallReason={uninstallReason}
                                onlyProduction={onlyProduction}
                                onDataLoad={({ data, total }) => {
                                    setTableData(data);
                                    setTotalRows(total);
                                }}
                            />
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}
